import { addMinutes } from "@/helpers/dateHelper";

export default class LocalStorage {
  static addWithTimout(guid: string, data: any, expires?: Date | null) {
    if (expires === null) {
      expires = addMinutes(new Date(), 120);
    }
    const object = { value: data, expires: expires };
    localStorage.setItem(window.location.host + "_" + guid, JSON.stringify(object));
    this.clean();
  }

  static delete(guid: string) {
    localStorage.removeItem(window.location.host + "_" + guid);
    this.clean();
  }

  static get(guid: string) {
    this.clean();
    return localStorage.getItem(window.location.host + "_" + guid);
  }

  static getJsonParsed(guid: string) {
    this.clean();
    const item = localStorage.getItem(window.location.host + "_" + guid);
    if(item){
      return JSON.parse(item);
    }
  }

  static add(guid: string, data: any) {
    localStorage.setItem(window.location.host + "_" + guid, JSON.stringify(data));
  }

  static clean() {
    const keys = Object.keys(localStorage);
    let i = 0;
    let key = "";
    const countKeys = keys.length;

    const now = new Date();

    for (i = 0; i < countKeys; i++) {
      key = keys[i];
      if (key.startsWith(window.location.host + "_")) {
        const p = localStorage.getItem(key);
        if (p === null) {
          continue;
        }
        let o: any = null;
        try {
          o = JSON.parse(p);
          if (o == null) {
            continue;
          }
        } catch {
          continue;
        }
        if (o.expires) {
          const expiry = new Date(o.expires);
          const diff = expiry.getTime() - now.getTime();
          if (diff < 0) {
            localStorage.removeItem(key);
          }
        }
      }
    }
  }
}
